<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-tabs
                centered
                show-arrows
              >
                <v-tab>
                  <v-icon left>
                    mdi-list-box-outline
                  </v-icon>Информация
                </v-tab>
                <v-tab>
                  <v-icon left>
                    mdi-map-marker-outline
                  </v-icon>Адресные данные
                </v-tab>
                <v-tab>
                  <v-icon left>
                    mdi-phone
                  </v-icon>Контактные данные
                </v-tab>
                <v-tab>
                  <v-icon left>
                    mdi-bank
                  </v-icon>Банковские реквизиты
                </v-tab>
                <v-tab>
                  <v-icon left>
                    mdi-account-group
                  </v-icon>Партнеры
                </v-tab>
                <v-tab-item>
                  <!--<v-row class="justify-center">
                    <v-col cols="12" lg="12" xl="6">
                      <v-autocomplete
                          clearable
                          :filter="client_filter"
                          v-model="form.client"
                          :items="select.clients"
                          item-value="id"
                          label="Родительский клиент"
                          :loading="search.client.loading"
                          :search-input.sync="search.client.text"
                          hide-no-data
                          hint="Введите минимум три символа для поиска"
                          v-if="$store.state.access[28][5]"
                        >
                          <template v-slot:selection="{item}">
                            <v-list>
                              <v-list-item-content>
                                <v-list-item-title> {{ item.legal.name.short || item.legal.name.full }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list>
                          </template>
                          <template v-slot:item="{item}">
                            <v-list two-line>
                              <v-list-item-content>
                                <v-list-item-title>  {{ item.legal.name.short || item.legal.name.full }}</v-list-item-title>
                                <v-list-item-subtitle>ИНН: {{item.legal.inn}} КПП: {{item.legal.kpp}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list>
                          </template>
                        </v-autocomplete>
                    </v-col>
                  </v-row>-->
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="form.created"
                        label="Дата создания"
                        type="date"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="form.number"
                        label="Системный номер"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-select
                        v-model="form.state"
                        label="Статус"
                        :items="select.state"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="form.balance"
                        label="Баланс счета"
                        readonly
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-select
                        v-model="form.country"
                        label="Страна"
                        :items="select.country"
                        :disabled="view"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.legal.name.full"
                        name="legal_name_full"
                        label="Полное наименование"
                        :disabled="view"
                        @input="legal_full_name_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="form.legal.ogrn"
                        name="legal_ogrn"
                        label="ОГРН"
                        :disabled="view"
                        @input="legal_ogrn_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="form.legal.ogrn_date"
                        name="legal_ogrn_date"
                        type="date"
                        label="Дата выдачи ОГРН"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="form.legal.inn"
                        name="legal_inn"
                        label="ИНН"
                        :disabled="view"
                        @input="legal_inn_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="form.legal.kpp"
                        name="legal_kpp"
                        label="КПП"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.legal.director.post"
                        name="legal_director_post"
                        label="Должность руководителя"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-text-field
                        v-model="form.legal.director.name"
                        name="legal_director_name"
                        label="ФИО Руководителя"
                        :disabled="view"
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row
                    v-for="(address,index) in form.addresses"
                    :key="'addr'+ index"
                  >
                    <v-col cols="12">
                      <v-select
                        v-model="address.type"
                        :items="select.address_type"
                        label="Тип адреса"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col cols="10">
                      <v-text-field
                        v-model="address.value"
                        label="Адрес"
                        :disabled="view"
                        :name="'address' + String(address.index)"
                        @input="adress_input(address)"
                      />
                    </v-col>
                    <v-col cols="2">
                      <v-icon @click="form.addresses = form.addresses.filter(a=>a!=address)">
                        mdi-delete
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      class="text-left"
                      md="6"
                    >
                      <v-btn
                        text
                        color="primary"
                        @click="form.addresses.push({value: '', type: 3})"
                      >
                        <v-icon
                          large
                          class="mr-2"
                          color="primary"
                        >
                          mdi-plus-circle-outline
                        </v-icon>
                        ДОБАВИТЬ АДРЕС
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row
                    v-for="(item, index) in form.phones"
                    :key="'ph' + index"
                  >
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="item.number"
                        label="Значение"
                        class="purple-input"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                    >
                      <v-select
                        v-model="item.type"
                        label="Тип"
                        class="purple-input"
                        :disabled="view"
                        :items="select.phone"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                    >
                      <v-icon
                        large
                        @click="form.phones = form.phones.filter(a=>a!=item)"
                      >
                        mdi-minus
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      class="text-left"
                      md="6"
                    >
                      <v-btn
                        text
                        color="primary"
                        @click="form.phones.push({})"
                      >
                        <v-icon
                          large
                          class="mr-2"
                          color="primary"
                        >
                          mdi-plus-circle-outline
                        </v-icon>
                        ДОБАВИТЬ КОНТАКТ
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-text-field
                        v-model="form.requisites.bank_name"
                        name="bank"
                        color="secondary"
                        label="Банк"
                        :disabled="view"
                        @input="bank_input"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="form.requisites.bic"
                        color="secondary"
                        label="Бик"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.requisites.ks"
                        color="secondary"
                        label="К/с"
                        :disabled="view"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.requisites.rs"
                        color="secondary"
                        label="Р/с"
                        :disabled="view"
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      lg="12"
                      xl="6"
                    >
                      <v-data-table
                        disable-sort
                        :items="form.clients"
                        :headers="[{
                                     value: 'name',
                                     text: 'Наименование'
                                   },
                                   {
                                     value: 'setting',
                                     text: 'Настройка'
                                   },
                                   {
                                     value: 'action',
                                     text: 'Действие'
                                   }]"
                        :footer-props="datatable_footer"
                        no-data-text="Нет данных для отображения"
                      >
                        <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                          {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                        </template>
                        <template v-slot:item.name="{item}">
                          {{ item.legal.name.short }}
                        </template>
                        <template v-slot:item.setting="{item}">
                          <v-checkbox
                            v-model="item.parent_can_view_children"
                            label="Доступ к данным дочерних партнеров"
                          />
                        </template>
                        <template v-slot:item.action="{item}">
                          <v-icon
                            large
                            @click="delete_client(item)"
                          >
                            mdi-minus-circle-outline
                          </v-icon>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      class="text-center"
                      lg="12"
                      xl="6"
                    >
                      <v-btn
                        text
                        color="primary"
                        @click="show_add_client_dialog()"
                      >
                        <v-icon
                          large
                          class="mr-2"
                          color="primary"
                        >
                          mdi-plus-circle-outline
                        </v-icon>
                        Добавить партнера
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="6"
              lg="3"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              v-if="change"
              cols="6"
              lg="3"
              class="text-right"
            >
              <v-btn
                color="primary"
                class="ml-auto"
                @click="save_client"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
            <v-col
              v-else
              cols="6"
              lg="3"
              class="text-right"
            >
              <v-btn
                color="primary"
                class="ml-auto"
                @click="create_client"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-dialog
      v-model="dialog.event.show"
      scrollable
      persistent
    >
      <event-form
        :create="dialog.event.create"
        :view="dialog.event.view"
        :change="dialog.event.change"
        :data="dialog.event.data"
        :show="dialog.event.show"
        @close="dialog.event.show = false, load_events()"
      />
    </v-dialog>
    <v-dialog
      v-model="dialog.client.show"
      max-width="50%"
    >
      <v-card class="ma-n1">
        <v-card-title>Выберите пользователей</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="dialog.client.selected"
                clearable
                :filter="client_filter"
                :items="select.clients"
                return-object
                label="Дочерний клиент"
                :loading="search.client.loading"
                :search-input.sync="search.client.text"
                hide-no-data
                hint="Введите минимум три символа для поиска"
              >
                <template v-slot:selection="{item}">
                  <v-list>
                    <v-list-item-content>
                      <v-list-item-title v-if="item.legal">
                        {{ item.legal.name.short || item.legal.name.full }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </template>
                <template v-slot:item="{item}">
                  <v-list two-line>
                    <v-list-item-content>
                      <v-list-item-title v-if="item.legal">
                        {{ item.legal.name.short || item.legal.name.full }}
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="item.legal">
                        ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="mx-1">
            <v-col
              cols="6"
              lg="6"
            >
              <v-btn
                color="primary"
                outlined
                @click="dialog.client.show = false"
              >
                <span class="mx-3">Отмена</span>
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              lg="6"
              class="text-right"
            >
              <v-btn
                color="primary"
                @click="add_client"
              >
                <span class="mx-3">Добавить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff'
  import EventForm from './../EventForm'
  export default {
    components: { EventForm },
    props: ['create', 'change', 'view', 'show', 'item'],
    data: () => ({
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      event: {
        items: [],
        form: {
          type: 0,
          client: '',
        },
      },
      selected: {
      },
      info: {

      },
      loader: {
        show: false,
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },
        client: {
          show: false,
          selected: []
        },
      },
      events: [

      ],
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'filename',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
        ],
        contract: {
          headers: [{
                      sortable: false,
                      text: 'Действия',
                      value: 'action',
                    },
                    {
                      text: 'Договор',
                      value: 'number',
                    },
          ],
        },
      },
      tabs: [
        'Реквизиты',
        'Контактная информация',
        'Сотрудники',
        'Файлы',
      ],
      data: {
        phone: '',
      },
      form: {
        clients: [],
        client: '',
        legal: {
          name: {
            full: '',
            short: ''
          },
          ogrn: '',
          ogrn_date: '',
          inn: '',
          kpp: '',
          okved: [],
          director: {
            name: '',
            post: ''
          },
          tax: {
            authority: '',
            system: ''
          },
        },
        files: [],
        type: 1,
        surname: '',
        name: '',
        patronymic: '',
        email: '',
        country: 0,
        birthday: null,
        birthplace: '',
        phones: [],
        documents: [],
        addresses: [
          {
            index: 1,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 1,
            suggestion: false,
          },
          {
            index: 2,
            value: '',
            data: {
              postal_code: '',
              region_iso_code: '',
              region_with_type: '',
              city_with_type: '',
              street_with_type: '',
            },
            type: 2,
            suggestion: false,
          },
        ],
        requisites: {
          name: '',
          rs: '',
          ks: '',
          bic: '',
        },
        socials: [],
      },
      logs: [],
      dict: {
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Юридический адрес',
          2: 'Фактический адрес',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
      },
      select: {
        address_type: [
          { value: 1, text: 'Юридический' },
          { value: 2, text: 'Фактический' },
          { value: 3, text: 'Другой' }
        ],
        phone: [
          { value: 1, text: 'Телефон' },
          { value: 2, text: 'E-mail' },
          { value: 3, text: 'Сайт' },
          { value: 4, text: 'Соцсеть' },
        ],
        document: [
          { value: 1, text: 'Паспорт' },
          { value: 2, text: 'Водительское удостоверение' },
          { value: 10, text: 'Иное' },
        ],
        type: [
          { value: 1, text: 'Собственник ТС' },
          { value: 2, text: 'Водитель' },
          { value: 10, text: 'Иное' },
        ],
        social: [
          { value: 1, text: 'ВКонтакте' },
          { value: 2, text: 'Facebook' },
          { value: 3, text: 'Instagram' },
          { value: 4, text: 'Twitter' },
        ],
        event: [
          { value: 1, text: 'Звонок' },
        ],
        doc_type: [
          { value: 1, text: 'Свидетельство о регистрации ТС' },
          { value: 2, text: 'Паспорт ТС' },
          { value: 3, text: 'Паспорт самоходной машины' },
          { value: 4, text: 'Аналогичный документ' },
        ],
        state: [
          { value: 0, text: 'Новый' },
          { value: 1, text: 'Активный' },
          { value: 2, text: 'Заблокирован' },
          { value: 3, text: 'Удален' }
        ],
        country: [
          { value: 643, text: 'Россия' },
          { value: 417, text: 'Кыргызстан' }
        ],
        clients: []
      },
       search: {
        client: {
          loading: false,
          text: ''
        },
      },
      suggestion: {
        bank: false,
        requisites: false,
        legal_requisites: false,
      },
    }),
    computed: {
      title: {
        get: function () {
          if (this.create) return 'Создание'
          if (this.change) return 'Изменение'
          if (this.view) return 'Просмотр'
          return ''
        },
      },
    },
    watch: {
      /* view: function () {
        if (this.view) this.load()
      },
      change: function () {
        if (this.change) this.load()
      }, */
      'search.client.text': function () {
        if (this.search.client.text) { this.load_clients(this.search.client.text) }
      },
      'data.phone': function () {
        if (this.data.phone) {
          var phone = this.form.phones.find(a => a.main)
          if (phone) {
            phone.number = this.data.phone
          } else {
            this.form.phones.push({ number: this.data.phone, main: true, type: 1 })
          }
        }
      },
      show: function () {
        if (this.show) {
          if (this.change) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }

          if (this.view) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }
          if (this.create) {
            this.form = {
              files: [],
              type: 1,
              surname: '',
              name: '',
              patronymic: '',
              email: '',
              birthday: null,
              birthplace: '',
              phones: [],
              documents: [],
              addresses: [
                {
                  index: 1,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 1,
                  suggestion: false,
                },
                {
                  index: 2,
                  value: '',
                  data: {
                    postal_code: '',
                    region_iso_code: '',
                    region_with_type: '',
                    city_with_type: '',
                    street_with_type: '',
                  },
                  type: 2,
                  suggestion: false,
                },
              ],
              bank: {
                name: '',
                rs: '',
                ks: '',
                bic: '',
              },
              socials: [],
            }
          }
        }
      },
    },
    mounted: function () {
      if (this.create) {
        this.form.created = moment().format('YYYY-MM-DD')
      }
      for (const x in this.$store.state.dict.insurer) {
        this.dict.insurer[Number(x)] = this.$store.state.dict.insurer[x].name
        this.select.insurer.push({ value: Number(x), text: this.$store.state.dict.insurer[x].name })
      }
      var id = null
      if (this.item && this.item.id) id = this.item.id
      else
        if (this.$route.query.id && (this.view || this.change)) id = this.$route.query.id
      if (id) {
        this.axios.post('/api/client/get', { id: id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data
              if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
              this.form.requisites = this.form.requisites || {}
              this.form.legal = this.form.legal || {}
              this.form.legal.name = this.form.legal.name || {}
              this.form.legal.director = this.form.legal.director || {}
              this.form.addresses = this.form.addresses || []
              this.form.phones = this.form.phones || []
              this.form.clients = this.form.clients || []
              if (this.form.client) {
                this.load_clients_id(this.form.client)
              }
              // this.load_events()
              this.load_logs()
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    methods: {
      get_color: function (item, type) {
        return 'white'
      },
      delete_client: function (item) {
        if (confirm('Вы уверены?')) {
            this.form.clients = this.form.clients.filter(a => a != item)
          }
      },
      add_client: function () {
        console.log("adding client :" + this.dialog.client.selected)
        this.form.clients.push(this.dialog.client.selected)
        this.form.clients = this.form.clients.filter(a => true)
        console.log('clients: ' + this.form.clients)
        this.dialog.client.show = false
      },
      show_add_client_dialog: function () {
        this.dialog.client.selected = null
        this.dialog.client.show = true
      },
      client_filter: function (item, query, text) {
        if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {
          search: text,
          limit: 10
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      load_clients_id: function (id) {
        if (!id) return
        this.axios.post('/api/client/list', {
          id: id
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
            this.client_selected()
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      // load_events: function () {
      //   this.axios.post('/api/event/list', {
      //     client: this.form.id,
      //   })
      //     .then(result => {
      //       if (!result.data.error) {
      //         for (const x in result.data.data) {
      //           if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
      //           result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
      //           result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
      //           if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
      //         }
      //         this.events = result.data.data
      //       }
      //     })
      //     .catch(e => {
      //       console.log(e)
      //       this.$store.commit('snackbar', 'Ошибка при обновлении данных')
      //     })
      // },
      load_logs: function () {
        this.axios.post('/api/log/list', { entity: this.form.id, limit: 5 })
          .then(result => {
            if (!result.data.error) {
              this.logs = result.data.data || []
              for (const x in this.logs) {
                this.logs[x].date_text = moment(this.logs[x].date).format('DD.MM.YYYY HH:mm')
                this.logs[x].diff = (diff(JSON.parse(this.logs[x].old), (JSON.parse(this.logs[x].change))))
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          client: this.form.id,
          client_item: this.form,
        }
        console.log(this.dialog.event.data)
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      open_file: function (id, item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/client/file/' + this.form.id, data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                this.form = response.data.data
                console.log(this.form.files)
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      legal_short_name_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_name_short]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              try {
                console.log('data', data)
                this.form.legal.name.full = data.data.name.full_with_opf
                this.form.legal.name.short = data.data.name.short_with_opf
                this.form.legal.inn = data.data.inn
                this.form.legal.kpp = data.data.kpp
                this.form.legal.ogrn = data.data.ogrn
                this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
                this.form.legal.okved = data.data.okveds || [data.data.okved]
                this.form.legal.director = {}
                if (data.data.management) {
                  this.form.legal.director.name = data.data.management.name
                  this.form.legal.director.post = data.data.management.post
                }
                if (data.data.address) {
                  this.form.addresses =
                    [{
                    value: data.data.address.unrestricted_value,
                    data: data.data.address.data,
                    type: 1
                  }]
                }
                this.form.tax = {}
                console.log('data_end', this.form)
              } catch (err) {
                console.log('err', err)
              }
            },
          })
        }
      },
      legal_full_name_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_name_full]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.legal.name.full = data.data.name.full_with_opf
              this.form.legal.name.short = data.data.name.short_with_opf
              this.form.legal.inn = data.data.inn
              this.form.legal.kpp = data.data.kpp
              this.form.legal.ogrn = data.data.ogrn
              this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
              this.form.legal.okved = data.data.okveds || [data.data.okved]
              this.form.legal.director = {}
              if (data.data.management) {
                this.form.legal.director.name = data.data.management.name
                this.form.legal.director.post = data.data.management.post
              }
               if (data.data.address) {
                  this.form.addresses =
                    [{
                    value: data.data.address.unrestricted_value,
                    data: data.data.address.data,
                    type: 1
                  }]
                }
              this.form.tax = {}
            },
          })
        }
      },
      legal_inn_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_inn]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.legal.name.full = data.data.name.full_with_opf
              this.form.legal.name.short = data.data.name.short_with_opf
              this.form.legal.inn = data.data.inn
              this.form.legal.kpp = data.data.kpp
              this.form.legal.ogrn = data.data.ogrn
              this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
              this.form.legal.okved = data.data.okveds || [data.data.okved]
              this.form.legal.director = {}
              if (data.data.management) {
                this.form.legal.director.name = data.data.management.name
                this.form.legal.director.post = data.data.management.post
              }
              this.form.tax = {}
            },
          })
        }
      },
      legal_ogrn_input: function (item) {
        if (!this.suggestion.legal_requisites) {
          this.suggestion.legal_requisites = true
          $('[name=legal_ogrn]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.legal.name.full = data.data.name.full_with_opf
              this.form.legal.name.short = data.data.name.short_with_opf
              this.form.legal.inn = data.data.inn
              this.form.legal.kpp = data.data.kpp
              this.form.legal.ogrn = data.data.ogrn
              this.form.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
              this.form.legal.okved = data.data.okveds || [data.data.okved]
              this.form.legal.director = {}
              if (data.data.management) {
                this.form.legal.director.name = data.data.management.name
                this.form.legal.director.post = data.data.management.post
              }
              this.form.tax = {}
            },
          })
        }
      },
      bank_input: function (item) {
        if (!this.suggestion.requisites) {
          this.suggestion.requisites = true
          $('[name=bank]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              console.log(data)
              this.form.requisites.bank_name = data.data.name.full || data.data.name.payment
              this.form.requisites.bic = data.data.bic
              this.form.requisites.ks = data.data.correspondent_account
            },
          })
        }
      },
      adress_input: function (item) {
        if (!item.suggestion) {
          console.log('[name=address' + String(item.index) + ']')
          item.suggestion = true
          $('[name=address' + String(item.index) + ']').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              item.value = data.unrestricted_value
              item.data = data.data
              console.log(item)
            },
          })
        }
      },
      create_client: function () {
        this.$emit('create', this.form)
      },
      save_client: function () {
        if (this.form.id) {
          this.axios.post('/api/client/save', this.form)
            .then(result => {
              if (!result.data.error) {
                console.log(result)
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                // if (!this.item) this.$router.push('/admin/client/view?id=' + this.form.id)
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        } else { this.$emit('change', this.form) }
      },
    },
  }
</script>
